import React, { useState } from 'react';
import { Check, Star } from 'lucide-react';
import { pricingPlans } from '../data/mock';

const Pricing = () => {
  const [hoveredPlan, setHoveredPlan] = useState(null);

  return (
    <section id="pricing" className="pricing-section">
      <div className="section-container">
        <h2 className="section-title">Unsere Modelle für Ihre Dossier-Automatisierung</h2>
        
        <div className="pricing-grid">
          {pricingPlans.map((plan) => (
            <div 
              key={plan.id}
              className={`pricing-card ${plan.featured ? 'featured' : ''} ${hoveredPlan === plan.id ? 'hovered' : ''}`}
              onMouseEnter={() => setHoveredPlan(plan.id)}
              onMouseLeave={() => setHoveredPlan(null)}
            >
              {plan.featured && (
                <div className="pricing-badge">
                  <Star size={16} fill="currentColor" />
                  {plan.badge}
                </div>
              )}
              
              <div className="pricing-header">
                <h3 className="pricing-name">{plan.name}</h3>
                {plan.availability && (
                  <div className="pricing-availability">
                    {plan.availability}
                  </div>
                )}
                <p className="pricing-subtitle">{plan.subtitle}</p>
                <p className="pricing-description">{plan.description}</p>
              </div>

              <div className="pricing-cost">
                <div className="pricing-initial">
                  <span className="pricing-label">Initialinvestition</span>
                  <span className="pricing-amount">Ab {plan.initialInvestment} CHF</span>
                </div>
                
                <div className="pricing-monthly">
                  <div className="pricing-price">
                    <span className="pricing-currency">CHF</span>
                    <span className="pricing-value">{plan.monthlyPrice}</span>
                    <span className="pricing-period">/Monat</span>
                  </div>
                  {plan.period && (
                    <span className="pricing-period-note">{plan.period}</span>
                  )}
                </div>
              </div>

              <div className="pricing-features">
                {plan.features.map((feature, index) => (
                  <div key={index} className="pricing-feature">
                    <Check size={18} className="feature-check" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <a 
                href={plan.calLink}
                target="_blank"
                rel="noopener noreferrer"
                className={`pricing-cta ${plan.featured ? 'btn-primary' : 'btn-secondary'}`}
              >
                Kostenlose Bedarfsabklärung buchen
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
